import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckCircle, Mail, MessageCircle, Calendar, Download, Home } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

const CheckoutSuccessPage = () => {
  const { enrollmentId } = useParams();
  const navigate = useNavigate();
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    setTimeout(() => setShowConfetti(false), 3000);
  }, []);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4 relative overflow-hidden">
      {/* Confetti effect */}
      {showConfetti && (
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              className="absolute w-2 h-2 bg-red-500 rounded-full animate-ping"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
                animationDuration: `${1 + Math.random() * 2}s`
              }}
            />
          ))}
        </div>
      )}

      <Card className="bg-zinc-900 border-zinc-800 max-w-2xl w-full">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4">
            <CheckCircle className="text-green-500 w-20 h-20 mx-auto" />
          </div>
          <CardTitle className="text-3xl text-white mb-2">
            Matrícula Confirmada! 🎉
          </CardTitle>
          <p className="text-gray-400">
            Sua matrícula foi realizada com sucesso!
          </p>
          <Badge className="bg-green-600 text-white mx-auto mt-4">
            ID: {enrollmentId}
          </Badge>
        </CardHeader>

        <CardContent className="space-y-6">
          {/* O que aconteceu */}
          <div className="bg-zinc-800 rounded-lg p-6 space-y-4">
            <h3 className="text-white font-semibold text-lg mb-4">✓ Próximos Passos</h3>
            
            <div className="flex items-start space-x-3">
              <Mail className="text-red-500 mt-1" size={20} />
              <div className="flex-1">
                <div className="text-white font-medium">Email de Confirmação Enviado</div>
                <div className="text-sm text-gray-400">
                  Verifique sua caixa de entrada. Você receberá:
                  <ul className="list-disc list-inside mt-2 space-y-1">
                    <li>Mensagem de boas-vindas</li>
                    <li>Calendário completo das aulas</li>
                    <li>Instruções de acesso</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <MessageCircle className="text-red-500 mt-1" size={20} />
              <div className="flex-1">
                <div className="text-white font-medium">WhatsApp Configurado</div>
                <div className="text-sm text-gray-400">
                  <ul className="list-disc list-inside mt-2 space-y-1">
                    <li>Mensagem de confirmação enviada</li>
                    <li>Você foi adicionado ao grupo da turma</li>
                    <li>Aguarde a mensagem de boas-vindas</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <Calendar className="text-red-500 mt-1" size={20} />
              <div className="flex-1">
                <div className="text-white font-medium">Calendário das Aulas</div>
                <div className="text-sm text-gray-400">
                  O calendário completo com todas as datas e horários foi enviado por email.
                </div>
              </div>
            </div>
          </div>

          {/* Informações importantes */}
          <div className="bg-yellow-900/20 border border-yellow-700/30 rounded-lg p-4">
            <h4 className="text-yellow-400 font-semibold mb-2">📌 Importante</h4>
            <ul className="text-sm text-gray-300 space-y-1">
              <li>• Guarde o ID da matrícula para referência</li>
              <li>• Adicione o email contato@bimportal.com.br aos seus contatos</li>
              <li>• Salve o número da turma no WhatsApp</li>
              <li>• Aguarde até 24h para acesso à plataforma</li>
            </ul>
          </div>

          {/* Ações */}
          <div className="grid grid-cols-2 gap-4">
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="border-zinc-700 text-white"
            >
              <Home className="mr-2" size={18} />
              Voltar ao Início
            </Button>
            <Button
              onClick={() => window.print()}
              className="bg-red-600 hover:bg-red-700"
            >
              <Download className="mr-2" size={18} />
              Imprimir Comprovante
            </Button>
          </div>

          <div className="text-center text-sm text-gray-400 pt-4 border-t border-zinc-700">
            Dúvidas? Entre em contato: <span className="text-red-400">contato@bimportal.com.br</span> ou <span className="text-red-400">(61) 99579-2667</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CheckoutSuccessPage;